import { useState } from "react";
export default function SearchItem({data, moreInfoSetData}){
  const [searchResultElements, updateSearchResults] = useState([])
  const [userInput, changeUserInput] = useState("");
  const svg = (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
  </svg>);

const checkSpecificLetters = (text, checkAgainst) => { // checks for letters as well, ps4 inside of playstation 4
  let textArray = text.split('')
  let desicion = true
  textArray.every((character) => {
    console.log(character, checkAgainst)
    if( checkAgainst.toLowerCase().includes(character.toLowerCase()) === false){
      desicion = false
      return false
    }
    checkAgainst = checkAgainst.substring(checkAgainst.indexOf(character) + 1) // instead of seeing a character before the current, cut off the word to look ahead instead.
    return true
  });
  return desicion
}

  const updateSearch = (text) => {
    changeUserInput(text);
    if(text !== ""){
      try{
        let tempArray = Object.keys(data);
        console.log('Temp', data)
        let elements = tempArray.map((item,index) => {
          if((item.toLowerCase()).includes(text.toLowerCase()) || checkSpecificLetters(text, item)){
            let brand = data[item][0]["Brand"]
            return (<li key={index}>
              <h5>{brand + ' ' + data[item][0]["Device Model/Series"]}</h5><span onClick={()=>{moreInfoSetData(data[item][0])}} style={{marginLeft:2, cursor:"pointer"}}>{svg}</span>
            </li>)
          }
          return false;
        })
        updateSearchResults(elements)
      } catch (err) {
        console.log("Temp ERROR")
      }
    } else {
      updateSearchResults([])
    }
  }

  return (
    <div className="xfinity-deviceList-search-container">
        <input value={userInput} placeholder='Search for a device' onChange={(e) => {updateSearch(e.target.value)}}/>
        <ul style={{position:"relative", display:"flex"}}>
          {searchResultElements}
        </ul>
      </div>
  )
}